export const ReactQueryKeys = {
  applicationDetailsShortKey: ['applicationDetails'],
  applicationDetails: (applicationId: string) => [
    'applicationDetails',
    applicationId,
  ],
  channelByApplicationId: (applicationId: string) => [
    'channelByApplicationId',
    applicationId,
  ],
  globalChannelList: (companyId: string | undefined) => [
    'glintsChatChannelsGlobal',
    companyId,
  ],
  channelList: (params: Record<string, unknown>, companyId?: string) => [
    'glintsChatChannels',
    companyId,
    params,
  ],
  messageList: (channelId: string) => ['glintsChatMessages', channelId],
  messageListShort: ['glintsChatMessages'],
  channelsUnreadCount: (channelIds: string[]) => {
    // Convert array to object so the key is not order dependent
    const channelIdsMap = channelIds.reduce(
      (acc, channelId) => {
        acc[channelId] = channelId;
        return acc;
      },
      {} as Record<string, string>
    );

    return ['channelsUnreadCount', channelIdsMap] as const;
  },
  getExpiringApplications: (jid: string) => ['getExpiringApplications', jid],
  getSalarySuggestion: (
    jobCategoryId?: string,
    locationId?: string,
    jobType?: string
  ) => ['getSalarySuggestion', jobCategoryId, locationId, jobType],
  locationSuggestions: (text: string, cityId?: string) => [
    'locationSuggestions',
    text,
    cityId,
  ],
  orgNameSuggestions: (text: string) => ['orgNameSuggestions', text],
  reverseGeocode: (
    coordinate: {
      latitude: number;
      longitude: number;
    } | null
  ) => ['reverseGeocode', coordinate?.latitude, coordinate?.longitude],
  companyAddresses: (companyId: string | undefined) => [
    'companyAddresses',
    companyId,
  ],
  expiringInventories: (companyId: string | undefined) => [
    'expiringInventories',
    companyId,
  ],
  updatePhone: () => ['updatePhone'],
  featureCount: (companyId: string) => ['featureCount', companyId],
  featureCountHotJobs: (companyId: string) => [
    'featureCountHotJobs',
    companyId,
  ],
  jobFeatureCount: (companyId: string, jobId: string) => [
    'jobFeatureCount',
    companyId,
    jobId,
  ],
  featureConfig: () => ['featureConfig'],
  jobFeatureConfig: (jobId: string) => ['jobFeatureConfig', jobId],
  shareUrl: (targetId: string) => ['shareUrl', targetId],
  jobShareIncentive: (targetId: string, countryCode: string) => [
    'jobShareIncentive',
    targetId,
    countryCode,
  ],
  jobPostingConfig: (jobRoleId: string, companyId: string) => [
    'jobPostingConfig',
    jobRoleId,
    companyId,
  ],
  suggestedJobValues: (
    companyId: string,
    jobRoleId: string,
    locationId: string,
    jobId?: string,
    jobTitle?: string
  ) => [
    'suggestedJobValues',
    companyId,
    jobRoleId,
    locationId,
    jobId,
    jobTitle,
  ],
  s3FileUrl: (key: string, label: string, filename?: string) => [
    's3FileUrl',
    key,
    label,
    filename,
  ],
  resumeData: (key: string, label: string, filename?: string) => [
    'resumeData',
    key,
    label,
    filename,
  ],
  createVirtualProductOrder: () => ['createVirtualProductOrder'],
  createRechargeOrder: () => ['createRechargeOrder'],
  initiatePayment: () => ['initiatePayment'],
  fallbackPaymentProviders: (orderNumber: string) => [
    'fallbackPaymentProviders',
    orderNumber,
  ],
  fallbackPaymentProvider: (
    orderNumber: string,
    providerType: string,
    paymentMethod: string
  ) => ['fallbackPaymentProvider', orderNumber, providerType, paymentMethod],
  orderStatus: (orderNumber: string) => ['orderStatus', orderNumber],
  virtualProductOrderDetails: (orderNumber: string) => [
    'virtualProductOrderDetails',
    orderNumber,
  ],
  purchasePreview: (
    orderType: string,
    id: string,
    companyId: string,
    additionalJobSlot?: number
  ) => [
    'purchasePreview',
    orderType,
    id,
    companyId,
    ...(additionalJobSlot !== undefined ? [additionalJobSlot] : []),
  ],
  products: (type: string, companyId: string) => ['products', type, companyId],
  orders: (companyId: string, orderStatus?: string, cursor?: string) => [
    'orders',
    companyId,
    ...(orderStatus ? [orderStatus] : []),
    ...(cursor ? [cursor] : []),
  ],
  creditHistory: (
    companyId: string,
    cursor?: string,
    usages?: string[],
    creatorIds?: string[],
    sort?: 'ASC' | 'DESC'
  ) => [
    'creditHistory',
    companyId,
    {
      cursor,
      usages: usages?.length ? usages.slice().sort() : undefined,
      creatorIds: creatorIds?.length ? creatorIds.slice().sort() : undefined,
      sort,
    },
  ],
  productPurchases: (
    companyId: string | undefined,
    productType: string,
    cursor?: string
  ) => [
    'productPurchases',
    companyId,
    productType,
    ...(cursor ? [cursor] : []),
  ],
  pendingPaymentsNotification: (companyId: string) => [
    'pendingPaymentsNotification',
    companyId,
  ],
};
